import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { CheckBox } from "@app/components/Common";
import { View } from "@/styles/reactnative";
import CloseContext from "./CloseContext";
import ClosingPercentage from "./ClosingPercentage";
import ClosingQtyInput from "./ClosingQtyInput";
import { PositionCloseSection } from "./styles";
import PositionCloseConfirm from "./PositionCloseConfirm";
import { useIndexPrice } from "@app/hooks/trade/indexprice";
import { ThemeContext } from "@/theme/ThemeProvider";

const PositionCloseMarket = ({ item, setShowModal }) => {
  const { textw } = useContext(ThemeContext).theme.COLORS;
  const { t } = useTranslation();
  let { data: indexPrice } = useIndexPrice(item?.exchange_pairs_id);
  if (!indexPrice) {
    indexPrice = [{ price: 0 }];
  }
  const [percentage, setPercentage] = useState("100");
  const [closePrice, setClosePrice] = useState(indexPrice?.[0]?.price || 0);
  const [amount, setAmount] = useState(item?.amount);
  const [postOnly, setPostOnly] = useState(false);
  const handleChange = () => {
    setPostOnly(!postOnly);
  };

  return (
    <PositionCloseSection>
      <ClosingQtyInput amount={amount} setAmount={setAmount} />
      <ClosingPercentage
        percentage={percentage}
        setPercentage={setPercentage}
        amount={amount}
        setAmount={setAmount}
      />
      <CloseContext />
      <View style={{ marginTop: 20, alignItems: "flex-start" }}>
        <CheckBox
          labelStyle={{ marginLeft: 10, color: textw }}
          textStyle={{ color: textw }}
          label={t("postOnly")}
          value={postOnly}
          onChange={handleChange}
        />
      </View>
      <PositionCloseConfirm
        setShowModal={setShowModal}
        item={item}
        limitmarket={"M"}
        closePrice={closePrice || 0}
        postOnly={postOnly}
        amount={amount}
      />
    </PositionCloseSection>
  );
};

export default PositionCloseMarket;
